var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecurringCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "166px",
    height: "122px",
    viewBox: "0 0 166 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-4-/-one-conf-updated-icons",
    transform: "translate(-634.000000, -520.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(549.000000, 520.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(86.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131,110.343396 C131,116.616048 108.390412,121.692771 80.5010236,121.692771 C52.6095875,121.692771 30,116.616048 30,110.343396 C30,104.076723 52.6095875,99 80.5010236,99 C108.390412,99 131,104.076723 131,110.343396",
    id: "Fill-9-Copy",
    fill: "#E6F9FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.1376091,0 C41.3968608,0 7.55796446,33.8486258 7.55796446,75.6013754 C7.55796446,86.7242277 9.97840258,97.2762897 14.2921108,106.786943 L151.983107,106.786943 C156.296816,97.2762897 158.717254,86.7242277 158.717254,75.6013754 C158.717254,33.8486258 124.878357,0 83.1376091,0 Z",
    id: "Fill-1",
    fill: "#E6F9FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 106.000000)",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50271002,0.786942734 L155.883017,0.786942734",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.786942734 L4.72372779,0.786942734",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.661999,0.786942734 L164.385727,0.786942734",
    id: "Stroke-7"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(33.000000, 34.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-18-Copy-4",
    stroke: "#054C70",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 96.1238201,
    height: 75.3653413,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    fill: "#05C3DE",
    x: 40.8023124,
    y: 31.4278022,
    width: 18.6293534,
    height: 14.568573
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7-Copy",
    fill: "#05C3DE",
    x: 20.6388118,
    y: 61.5979156,
    width: 20.6388118,
    height: 14.568573
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-18",
    stroke: "#054C70",
    x: 0.5,
    y: 0.5,
    width: 96.1238201,
    height: 75.3653413,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,17.2561395 L96.6238201,17.2561395 L96.6238201,4 C96.6238201,2.06700338 95.0568167,0.5 93.1238201,0.5 L4,0.5 C2.06700338,0.5 0.5,2.06700338 0.5,4 L0.5,17.2561395 Z",
    id: "Rectangle-19",
    stroke: "#054C70",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(38.190964, 7.426021)",
    stroke: "#054C70",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.59129018 L21.2172024,1.59129018",
    id: "Line-5-Copy"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.29777518,31.4560404 L95.8260449,31.4560404",
    id: "Line-6",
    stroke: "#054C70",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29777518,46.526978 L95.8260449,46.526978",
    id: "Line-6-Copy",
    stroke: "#054C70",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29777518,61.5979156 L95.8260449,61.5979156",
    id: "Line-6-Copy-2",
    stroke: "#054C70",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7225392,17.2956386 L20.7225392,75.4443399",
    id: "Line-7",
    stroke: "#054C70",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8996678,18.1329129 L40.8996678,75.0675661",
    id: "Line-7-Copy",
    stroke: "#054C70",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3732146,18.2794359 L59.3732146,75.4443395",
    id: "Line-7-Copy-2",
    stroke: "#054C70",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3327485,18.2794359 L77.3327485,75.4443395",
    id: "Line-7-Copy-3",
    stroke: "#054C70",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(69.866940, 48.033833)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#054C70",
    fill: "#FFFFFF",
    cx: 15.4344935,
    cy: 15.4344935,
    r: 15.4344935
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.717247, 7.717247)",
    stroke: "#05C3DE",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.96724675,0 L7.96724675,15.4344935",
    id: "Line-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.71724675 L15.4344935,7.71724675",
    id: "Line-4"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringCalendar);
export default __webpack_public_path__ + "static/media/recurring-calendar.c6fb1f861c34cd008c21f07a61710be2.svg";
export { ForwardRef as ReactComponent };